"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var FlatFilter_1 = require("../../../helpers/Functions/FlatFilter");
var Join_1 = require("../../../helpers/Functions/Join");
var Simplify_1 = require("../../../helpers/Functions/Simplify");
var Link_1 = require("../Link");
/**
 * A list of utility links, styled according to global styles.
 */
var LinkList = function (props) {
    var _a = Simplify_1.simplify(props), links = _a.links, _b = _a.kind, kind = _b === void 0 ? "utilitySecondary" : _b, _c = _a.onDark, onDark = _c === void 0 ? false : _c, position = _a.position, style = _a.style, className = _a.className, testId = _a.testId;
    var linkElements = FlatFilter_1.flatfilter(links).map(function (link, index) { return (React.createElement("li", { className: "border-bottom border-light-gray", "data-testid": testId, key: link.children || "link " + index },
        React.createElement(Link_1.default, __assign({ onDark: onDark, position: position, className: Join_1.join("flex", "justify-between", "solo", link.className), kind: kind }, link)))); });
    return linkElements.length > 0 ? (React.createElement("ul", { className: Join_1.join("link-utility-list", className), "data-testid": testId, style: style }, linkElements)) : null;
};
exports.default = LinkList;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/LinkList/LinkList.js
// module id = 1780
// module chunks = 8